import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Button, SelectField, TextField, DialogContainer } from "react-md";
import UploadFileIcon from "../../../../../assets/icons/upload-file-icon.png";
import "../styles/createAccountStyles.css";
import FontIcon from "react-md/lib/FontIcons";
import { Checkbox } from "@material-ui/core";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import AccountDashboardUtils from "../services/AccountDashboardUtils";
import EventService from "../../../../../service/event/EventService";
import PlansUtils from "../services/PlansUtils";
import AvailabilityCalendar from "../../service-module/helper/AvailabilityCalendar";
import AuthenticationService from "../../../../../service/auth/AuthenticationService";
import CityTableCustomiseSP from "../helper/cityTableCustomiseSP";
import moment from "moment";
import { Modal } from "@material-ui/core";

export const CustomiseServiceProvider = (props) => {
  const [fetchedPlan, setFetchedPlan] = useState(null);
  const [fetchedService, setFetchedService] = useState(null);
  const [fetchedServiceProvider, setFetchedServiceProvider] = useState(null);
  const [fetchedAccount, setFetchedAccount] = useState(null);
  const [assignedServiceToPlan, setAssignedServiceToPlan] = useState(null);
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [customisedSP, setCustomisedSP] = useState(null);
  const [loading, setLoading] = useState(false);

  const [tableDataEditAudits, setTableDataEditAudits] = useState({});
  const [cityMappings, setCityMappings] = useState({});
  const [cityMappingFilters, setCityMappingFilters] = useState({});
  const [initialCityMapping, setInitialCityMapping] = useState({});
  const [cityMappingOperationSelected, setCityMappingOperationSelected] =
    useState(null);
  const [showUpdateCityMappingNowDialog, setShowUpdateCityMappingNowDialog] =
    useState(false);
  const [errorObject, setErrorObject] = useState(null);

  const [mode, setMode] = useState("update");
  const [originalMode, setOriginalMode] = useState("update");
  const [showAvailabilityBeyond, setShowAvailabilityBeyond] = useState(false);
  const [showUnavailabilityBeyond, setShowUnavailabilityBeyond] =
    useState(false);
  const [showAvailabilityModal, setShowAvailabilityModal] = useState(false);
  const [showUnavailabilityModal, setShowUnavailabilityModal] = useState(false);

  const [filterStartDate, setFilterStartDate] = useState(null);
  const [filterEndDate, setFilterEndDate] = useState(null);
  const [showDateFilter, setShowDateFilter] = useState(false);
  const today = moment().format("YYYY-MM-DD");
  const nextMonth = moment().add(1, "month").format("YYYY-MM-DD");

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(nextMonth);

  const [unFromDate, setUnFromDate] = useState(today);
  const [unToDate, setUnToDate] = useState(nextMonth);
  const [showUnDateFilter, setShowUnDateFilter] = useState(false);
  const [calendarData, setCalendarData] = useState([]);
  const [calendarMonth, setCalendarMonth] = useState(moment());
  const [showCalendarModal, setShowCalendarModal] = useState(false);

  const enablePricePerCityTextRef = useRef(null);

  const plansUtils = new PlansUtils();
  const authenticationService = new AuthenticationService();
  useEffect(() => {
    getPlanByFilter();
    getServicesByFilter();
    getProviderOfPlanService();
    fetchAssignedServiceToPlan();
  }, []);

  const reFetchPageData = () => {
    getPlanByFilter();
    getServicesByFilter();
    getProviderOfPlanService();
    fetchAssignedServiceToPlan();
  };

  const getFilteredAvailability = () => {
    if (!fromDate || !toDate) return availableDays;
    const from = moment(fromDate, "YYYY-MM-DD").startOf("day");
    const to = moment(toDate, "YYYY-MM-DD").endOf("day");
    return availableDays.filter((item) => {
      const itemDate = moment(item.date, [
        "YYYY-MM-DD",
        "DD/MM/YYYY",
        "DD-MM-YYYY",
        moment.ISO_8601,
      ]);
      if (!itemDate.isValid()) return false;
      return itemDate.isSameOrAfter(from) && itemDate.isSameOrBefore(to);
    });
  };

  const getFilteredUnavailability = () => {
    if (!unFromDate || !unToDate) return unavailableDays;
    const from = moment(unFromDate, "YYYY-MM-DD").startOf("day");
    const to = moment(unToDate, "YYYY-MM-DD").endOf("day");
    return unavailableDays.filter((item) => {
      const itemDate = moment(item.date, [
        "YYYY-MM-DD",
        "DD/MM/YYYY",
        "DD-MM-YYYY",
        moment.ISO_8601,
      ]);
      if (!itemDate.isValid()) return false;
      return itemDate.isSameOrAfter(from) && itemDate.isSameOrBefore(to);
    });
  };

  useEffect(() => {
    if (
      fetchedPlan != null &&
      fetchedService != null &&
      fetchedServiceProvider != null &&
      fetchedAccount != null &&
      assignedServiceToPlan != null
    ) {
      setIsDataFetched(true);

      let obj = {
        planId: fetchedPlan?.id,
        serviceId: fetchedService?.id,
        providerId: fetchedServiceProvider?.serviceProviderId,
        createdBy: authenticationService.getUserProfile().employeeProfile?.id,
        mode: fetchedServiceProvider.serviceModes[0].mode,
        isActive: fetchedServiceProvider.isActive == true ? "true" : "false",
        discountedPrice:
          fetchedServiceProvider.serviceModes[0].discountedPrice ?? "",
        providerAvailability:
          fetchedServiceProvider.serviceModes[0].availability,
        cityMappingPlan:
          fetchedServiceProvider?.serviceModes[0]?.cityMappingPlan ?? {},
      };

      setInitialCityMapping(
        (prev) =>
          fetchedServiceProvider?.serviceModes[0]?.cityMappingPlan ?? {},
      );

      fetchCityMappings(
        fetchedService?.id,
        fetchedServiceProvider?.serviceProviderId,
        fetchedPlan?.id,
        1,
        {},
      );

      setCustomisedSP(obj);
    }
  }, [fetchedPlan, fetchedService, fetchedServiceProvider, fetchedAccount]);

  const exitPage = () => {
    props.setView(4, {
      mode: "view",
      editMode: "service-providers",
      accountId: props?.data?.accountId,
      planId: props?.data?.planId,
      serviceId: props?.data?.serviceId,
    });
  };

  const handleUpdateMode = (mode) => {
    setMode(mode);
  };

  let fetchCityMappings = (
    serviceId,
    serviceProviderId,
    planId,
    pageNo,
    filters,
  ) => {
    setCityMappingFilters((prev) => ({ ...prev, ...filters }));
    setLoading(true);

    let onResponse = (res) => {
      setLoading(false);
      if (res != null) {
        setCityMappings((prev) => res);
      }
    };
    let onError = (err) => {
      setLoading(false);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.getL3CityMappingByFilter(
      {
        pageNo: pageNo,
        pageSize: 30,
        serviceProviderId: serviceProviderId, // always mandatory, rest are optional
        serviceId: serviceId,
        planId: planId,
        status: (filters?.status ?? [])?.map((ele) => ele.value) ?? [], // multiple supported as array
        name: filters?.name ?? "", // regex substring supported
      },
      onResponse,
      onError,
    );
  };

  const scrollToPricePerCityHeading = () => {
    requestAnimationFrame(() => {
      if (enablePricePerCityTextRef?.current) {
        enablePricePerCityTextRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    });
  };

  let checkIfThereIsAnythingToUpdate = () => {
    return (
      cityMappingOperationSelected === 2 &&
      (
        returnTableDataWithEditsAppliedWithOnlyEditedEntities(
          cityMappings ?? {},
          tableDataEditAudits ?? {},
        ) ?? []
      ).length > 0
    );
  };

  const returnTableDataWithEditsAppliedWithOnlyEditedEntities = (
    cityMappings,
    tableDataEditAudits,
  ) => {
    return mergeUpdatesWithOnlyEditedEntities(
      cityMappings?.cityEntities ?? [],
      tableDataEditAudits,
    );
  };

  const mergeUpdatesWithOnlyEditedEntities = (data, audits) => {
    // removing Deleted & entities with no change
    const finalCityMappings = (Object.values(audits ?? {}) ?? [])?.filter(
      (item) =>
        item?.status !== item?.originalEntity?.status ||
        item?.city !== item?.originalEntity?.price,
    );
    return finalCityMappings;
  };

  const getAccountByAccountCode = (code) => {
    let body = {
      pageNum: 1,
      pageSize: 1,
      accountCode: code,
    };
    const onResponse = (res) => {
      setFetchedAccount(res.accounts[0]);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.getAccountsByFilter(body, onResponse, onError);
  };

  const getPlanByFilter = () => {
    let body = {
      pageNum: 1,
      pageSize: 1,
      planIds: [props?.data?.planId],
    };
    const onResponse = (res) => {
      if (res.plans.length != 0) {
        setFetchedPlan(res.plans[0]);
        if (res.plans[0].accountCode != "") {
          getAccountByAccountCode(res.plans[0].accountCode);
        }
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.getPlanByFilter(body, onResponse, onError);
  };

  const getServicesByFilter = () => {
    let body = {
      pageNum: 1,
      pageSize: 1,
      Ids: [props?.data?.serviceId],
    };
    const onResponse = (res) => {
      if (res.services.length != 0) {
        setFetchedService(res.services[0]);
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.getServicesByFilter(body, onResponse, onError);
  };
  const getProviderOfPlanService = () => {
    let body = {
      pageNum: 1,
      pageSize: 1,
      serviceIds: [props?.data?.serviceId],
      serviceProviderIds: [props?.data?.serviceProviderId],
      planId: props?.data?.planId,
      mode: props?.data?.serviceMode,
      includeMarginRuleDetails: true,
    };
    const onResponse = (res) => {
      if (res.providers.length != 0) {
        let provider = res.providers[0];
        provider = {
          ...provider,
          serviceModes: provider.serviceModes.filter(
            (e) => e.mode == props?.data?.serviceMode,
          ),
        };
        setFetchedServiceProvider(provider);
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.getProviderOfPlanService(body, onResponse, onError);
  };

  const resetAddOrUpdateCities = () => {
    setTableDataEditAudits({});
  };

  const returnTableDataWithEditsApplied = (
    cityMappings,
    tableDataEditAudits,
  ) => {
    return mergeUpdates(cityMappings?.cityEntities ?? [], tableDataEditAudits);
  };

  const mergeUpdates = (data, audits) => {
    const mergedData = data.map((item) => {
      const audit = audits[item.id];
      return audit
        ? { ...item, ...audit } // merge original and audit (audit overrides)
        : item; // no change if no matching audit
    });

    return mergedData;
  };

  const handleUpdateTableCityEntity = (cityEntity, cityEntityOld) => {
    if (cityEntity?.id) {
      // if (cityEntity?.status === 3) {
      //   // delete entry from city Mappings
      //   const updatedCityMappings = (cityMappings?.cityEntities ?? []).filter(
      //     (item) => item.id !== cityEntity.id
      //   );
      //   setCityMappings((prev) => ({
      //     ...prev,
      //     cityEntities: updatedCityMappings,
      //   }));
      //   return;
      // }
      // checking whether it already exist in audits.. if yes , then it means it not the original value recieved from backend it has been updated atleast once on local.
      if (!Boolean(tableDataEditAudits?.[cityEntity.id])) {
        cityEntity["originalEntity"] = cityEntityOld;
      }

      setTableDataEditAudits((prev) => ({
        ...prev,
        [cityEntity.id]: cityEntity,
      }));
    }
  };

  let updateCustomisedSPCityToPriceMapping = () => {
    setLoading(true);
    let onResponse = (res) => {
      setLoading(false);
      if ((res?.totalErrors ?? 0) > 0) {
        setErrorObject((prev) => ({
          operation: 2,
          errorResponse: res?.errorResponse,
          totalRequested: res?.totalRequested,
          totalErrors: res?.totalErrors,
        }));
        EventService.emit("showError", {
          message: `City mappings updated partially with ${
            res?.totalErrors ?? 0
          } errors`,
        });
      } else {
        EventService.emit("showError", {
          message: `City mappings updated successfully`,
        });
      }
      setTableDataEditAudits((prev) => {});
      fetchCityMappings(
        customisedSP?.serviceId,
        customisedSP?.providerId,
        customisedSP?.planId,
        1,
        {},
      );
    };
    let onError = (err) => {
      setLoading(false);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.updateCustomisedSPCityToPriceMapping(
      {
        serviceId: customisedSP?.serviceId,
        serviceProviderId: customisedSP?.providerId,
        planId: customisedSP?.planId,
        cityEntities: (
          returnTableDataWithEditsAppliedWithOnlyEditedEntities(
            cityMappings ?? {},
            tableDataEditAudits ?? {},
          ) ?? []
        ).map(
          ({
            id,
            serviceProviderAssignCityId,
            serviceProviderPlanCityId,
            price,
            status,
          }) => ({
            cityId:
              (serviceProviderPlanCityId ?? "") == "" &&
              (serviceProviderAssignCityId ?? "") == ""
                ? id
                : null,
            serviceProviderAssignCityId:
              (serviceProviderPlanCityId ?? "") == ""
                ? serviceProviderAssignCityId
                : null,
            serviceProviderPlanCityId,
            price,
            status,
          }),
        ),
      },
      onResponse,
      onError,
    );
  };

  const fetchAssignedServiceToPlan = () => {
    const onResponse = (res) => {
      setAssignedServiceToPlan(res);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.fetchAssignedServiceToPlan(
      props?.data?.planId,
      props?.data?.serviceId,
      onResponse,
      onError,
    );
  };

  const setAvailability = (availability) => {
    setCustomisedSP({
      ...customisedSP,
      providerAvailability: { ...availability },
    });
  };

  const handleSave = () => {
    // do not check isDateValid for GYM type (because slots are required for gym membership type)
    if (fetchedService?.serviceTypeId == 4 || isDataValid()) {
      let body = {
        ...customisedSP,
        isActive: customisedSP.isActive == "true" ? true : false,
        discountedPrice: customisedSP.discountedPrice
          ? Number.parseInt(customisedSP.discountedPrice)
          : null,
      };

      if (fetchedServiceProvider.serviceModes[0].isCustomized) {
        updateCustomisedServiceProvider(
          body,
          !(initialCityMapping?.customisedPriceEnabled ?? false) &&
            (customisedSP?.cityMappingPlan?.customisedPriceEnabled ?? false) ===
              true,
        );
      } else {
        createCustomisedServiceProvider(
          body,
          !(initialCityMapping?.customisedPriceEnabled ?? false) &&
            (customisedSP?.cityMappingPlan?.customisedPriceEnabled ?? false) ===
              true,
        );
      }
    }
  };
  const createCustomisedServiceProvider = (
    body,
    showUpdateCityMappingNowDialog = false,
  ) => {
    setLoading(true);
    const onResponse = (res) => {
      setLoading(false);
      if (showUpdateCityMappingNowDialog) {
        setShowUpdateCityMappingNowDialog(true);
        return;
      }
      EventService.emit("showError", {
        message: `Service provider customised successfully`,
      });
      exitPage();
    };
    const onError = (err) => {
      setLoading(false);
      EventService.emit("showError", {
        message: `Error 1: ${err?.message}`,
      });
    };
    plansUtils.createCustomisedServiceProvider(body, onResponse, onError);
  };
  const updateCustomisedServiceProvider = (
    body,
    showUpdateCityMappingNowDialog = false,
  ) => {
    setLoading(true);
    const onResponse = (res) => {
      setLoading(false);
      if (showUpdateCityMappingNowDialog) {
        setShowUpdateCityMappingNowDialog(true);
        return;
      }
      EventService.emit("showError", {
        message: `Service provider customised successfully`,
      });
      exitPage();
    };
    const onError = (err) => {
      setLoading(false);
      EventService.emit("showError", {
        message: `Error 2: ${err?.message}`,
      });
    };
    plansUtils.updateCustomisedServiceProvider(body, onResponse, onError);
  };
  const isDataValid = () => {
    const hasEmptySlot = Object.keys(
      customisedSP.providerAvailability.schedule,
    ).some((day) =>
      (customisedSP.providerAvailability.schedule[day] ?? []).some(
        (slot) => slot.start === "" || slot.end === "",
      ),
    );
    if (hasEmptySlot) {
      EventService.emit("showError", {
        message: "Please fill all the slots in the schedule",
      });
      return false;
    } else if (
      customisedSP.providerAvailability.config.slotDurationInMinutes === null ||
      customisedSP.providerAvailability.config.slotDurationInMinutes === "" ||
      !(
        Number.isInteger(
          customisedSP.providerAvailability.config.slotDurationInMinutes,
        ) && customisedSP.providerAvailability.config.slotDurationInMinutes >= 0
      )
    ) {
      EventService.emit("showError", {
        message: "Please fill duration (mins)",
      });
      return false;
    } else if (
      customisedSP.providerAvailability.config.bookingPerSlot === null ||
      customisedSP.providerAvailability.config.bookingPerSlot === "" ||
      !(
        Number.isInteger(
          customisedSP.providerAvailability.config.bookingPerSlot,
        ) && customisedSP.providerAvailability.config.bookingPerSlot >= 0
      )
    ) {
      EventService.emit("showError", {
        message: "Please fill booking per slot ",
      });
      return false;
    } else if (
      customisedSP.providerAvailability.config.minBookingDays === null ||
      customisedSP.providerAvailability.config.minBookingDays === "" ||
      !(
        Number.isInteger(
          customisedSP.providerAvailability.config.minBookingDays,
        ) && customisedSP.providerAvailability.config.minBookingDays >= 0
      )
    ) {
      EventService.emit("showError", {
        message: "Please fill min booking notice (days)",
      });
      return false;
    } else if (
      customisedSP.providerAvailability.config.minBookingDays === null ||
      customisedSP.providerAvailability.config.minBookingDays === "" ||
      !(
        customisedSP.providerAvailability.config.minBookingDays >=
        fetchedServiceProvider.serviceModes[0].masterAvailability.config
          .minBookingDays
      )
    ) {
      EventService.emit("showError", {
        message:
          "Min booking notice (days) can't be lower than the minimum value",
      });
      return false;
    } else if (
      customisedSP.providerAvailability.config.maxAdvBookingDays == null ||
      customisedSP.providerAvailability.config.maxAdvBookingDays == "" ||
      !(
        Number.isInteger(
          customisedSP.providerAvailability.config.maxAdvBookingDays,
        ) && customisedSP.providerAvailability.config.maxAdvBookingDays >= 0
      )
    ) {
      EventService.emit("showError", {
        message: "Please fill max advance booking (days)",
      });
      return false;
    } else {
      return true;
    }
  };
  let STATUS_OPTIONS = [
    {
      label: "Active",
      value: "true",
    },
    {
      label: "Inactive",
      value: "false",
    },
  ];

  const modeData = fetchedServiceProvider?.serviceModes?.[0];

  const marginRuleDetails = modeData?.marginRuleDetails ?? null;
  const ruleData = marginRuleDetails?.rule ?? null;
  const marginData = marginRuleDetails?.margin ?? null;

  const availableDays = marginRuleDetails?.l2Availability?.availableTime ?? [];

  const unavailableDays =
    marginRuleDetails?.l2Availability?.unavailableTime ?? [];
  const isLevel4B =
    marginRuleDetails?.rule?.id && marginRuleDetails?.rule?.id !== "";

  const fetchCalendar = (monthMoment = calendarMonth) => {
    if (
      !fetchedService?.id ||
      !fetchedServiceProvider?.serviceProviderId ||
      !fetchedPlan?.id ||
      !monthMoment
    )
      return;

    const payload = {
      serviceId: fetchedService.id,
      providerId: fetchedServiceProvider.serviceProviderId,
      planId: fetchedPlan.id,
      mode: fetchedServiceProvider?.serviceModes?.[0]?.mode,
      fromL3Page: true,
      year: monthMoment.year(),
      month: monthMoment.month() + 1,
      ruleId: marginRuleDetails?.rule?.id,
    };

    console.log("Calendar payload:", payload); // 👈 debug

    plansUtils.getCalendar(
      payload,
      (res) => {
        setCalendarData(res?.calendarDays ?? []);
      },
      (err) => {
        EventService.emit("showError", {
          message: err?.message || "Failed to get calendar",
        });
      },
    );
  };

  const renderCalendarGrid = () => {
    if (!calendarData || calendarData.length === 0) return null;

    const month = calendarMonth.clone();

    // 🔥 Build lookup map (NO UTC)
    const dayTypeMap = new Map(calendarData.map((d) => [d.date, d.dayType]));

    // Monday start
    const start = month.clone().startOf("month").startOf("isoWeek");
    const end = month.clone().endOf("month").endOf("isoWeek");

    const days = [];
    let current = start.clone();

    while (current.isSameOrBefore(end)) {
      days.push(current.clone());
      current.add(1, "day");
    }

    const todayStr = moment().format("YYYY-MM-DD");

    return (
      <>
        <div className="calendar-weekdays">
          {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((w) => (
            <div key={w} className="calendar-weekday">
              {w}
            </div>
          ))}
        </div>

        <div className="calendar-grid">
          {days.map((date) => {
            const dateStr = date.format("YYYY-MM-DD"); // 🔥 no utc
            const dayType = dayTypeMap.get(dateStr);

            const isToday = dateStr === todayStr;

            const isCurrentMonth =
              date.month() === month.month() && date.year() === month.year();

            return (
              <div
                key={dateStr}
                className={`calendar-day
                ${dayType === 1 ? "available" : ""}
                ${dayType === 2 ? "disabled" : ""}
                ${!isCurrentMonth ? "muted" : ""}
                ${isToday ? "today" : ""}
              `}
              >
                {date.date()}
              </div>
            );
          })}
        </div>
      </>
    );
  };

  return (
    <div className="account-module-page-padding">
      <Modal
        open={showCalendarModal}
        onClose={() => setShowCalendarModal(false)}
      >
        <div className="calendar-modal-wrapper">
          <div className="calendar-modal">
            <div className="modal-header">
              <h2>Service provider availability calendar</h2>
              <span
                className="close-btn"
                onClick={() => setShowCalendarModal(false)}
              >
                ×
              </span>
            </div>

            {/* Navigation */}
            <div className="calendar-nav">
              <button
                onClick={() => {
                  const prev = calendarMonth.clone().subtract(1, "month");
                  setCalendarMonth(prev);
                  fetchCalendar(prev);
                }}
              >
                ‹
              </button>

              <strong>{calendarMonth.format("MMMM YYYY")}</strong>

              <button
                onClick={() => {
                  const next = calendarMonth.clone().add(1, "month");
                  setCalendarMonth(next);
                  fetchCalendar(next);
                }}
              >
                ›
              </button>
            </div>

            {renderCalendarGrid()}
          </div>
        </div>
      </Modal>

      {showAvailabilityModal && (
        <Modal
          open={showAvailabilityModal}
          onClose={() => setShowAvailabilityModal(false)}
        >
          <div className="availability-modal">
            <div className="modal-header">
              <h2>
                Service provider availability beyond master weekly schedule
              </h2>
              <span
                className="close-btn"
                onClick={() => setShowAvailabilityModal(false)}
              >
                ×
              </span>
            </div>

            <div className="table">
              <div className="table-header">
                <div className="date-header-container">
                  <div className="date-top-row">
                    <span className="date-label">Date</span>

                    <span
                      className="filter-icon"
                      onClick={() => setShowDateFilter(!showDateFilter)}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path d="M3 5h18l-7 8v6l-4-2v-4L3 5z" fill="#444" />
                      </svg>
                    </span>
                  </div>

                  <div className="date-range-text">
                    {moment(fromDate).format("DD MMM YYYY")} -{" "}
                    {moment(toDate).format("DD MMM YYYY")}
                  </div>
                </div>

                <span>Availability</span>
              </div>
              {showDateFilter && (
                <div className="date-filter-box">
                  <div className="date-field">
                    <label>From</label>
                    <div className="date-input-wrapper">
                      <input
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="date-field">
                    <label>To</label>
                    <div className="date-input-wrapper">
                      <input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                      />
                    </div>
                  </div>

                  <div
                    className="clear-filter"
                    onClick={() => {
                      setShowDateFilter(false);
                    }}
                  >
                    ×
                  </div>
                </div>
              )}

              {getFilteredAvailability().length === 0 ? (
                <div className="empty-state">No availability defined</div>
              ) : (
                getFilteredAvailability().map((item) => (
                  <div key={item.date} className="table-row">
                    <span>{moment(item.date).format("DD MMM YYYY")}</span>
                    <span>
                      {item.slots.map((s, i) => (
                        <span key={i}>
                          {s.start} - {s.end}
                          {i < item.slots.length - 1 && ", "}
                        </span>
                      ))}
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>
        </Modal>
      )}
      {showUnavailabilityModal && (
        <Modal
          open={showUnavailabilityModal}
          onClose={() => setShowUnavailabilityModal(false)}
        >
          <div className="availability-modal">
            <div className="modal-header">
              <h2>
                Service provider unavailability beyond master weekly schedule
              </h2>
              <span
                className="close-btn"
                onClick={() => setShowUnavailabilityModal(false)}
              >
                ×
              </span>
            </div>

            <div className="table">
              <div className="table-header">
                <div className="date-header-container">
                  <div className="date-top-row">
                    <span className="date-label">Date</span>

                    <span
                      className="filter-icon"
                      onClick={() => setShowUnDateFilter(!showUnDateFilter)}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path d="M3 5h18l-7 8v6l-4-2v-4L3 5z" fill="#444" />
                      </svg>
                    </span>
                  </div>

                  <div className="date-range-text">
                    {moment(unFromDate).format("DD MMM YYYY")} -{" "}
                    {moment(unToDate).format("DD MMM YYYY")}
                  </div>
                </div>

                <span>Non availability</span>
              </div>

              {showUnDateFilter && (
                <div className="date-filter-box">
                  <div className="date-field">
                    <label>From</label>
                    <div className="date-input-wrapper">
                      <input
                        type="date"
                        value={unFromDate}
                        onChange={(e) => setUnFromDate(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="date-field">
                    <label>To</label>
                    <div className="date-input-wrapper">
                      <input
                        type="date"
                        value={unToDate}
                        onChange={(e) => setUnToDate(e.target.value)}
                      />
                    </div>
                  </div>

                  <div
                    className="clear-filter"
                    onClick={() => {
                      setShowUnDateFilter(false);
                    }}
                  >
                    ×
                  </div>
                </div>
              )}

              {getFilteredUnavailability().length === 0 ? (
                <div className="empty-state">No unavailability defined</div>
              ) : (
                getFilteredUnavailability().map((item) => (
                  <div key={item.date} className="table-row">
                    <span>{moment(item.date).format("DD MMM YYYY")}</span>
                    <span>
                      {item.slots.map((s, i) => (
                        <span key={i}>
                          {s.start} - {s.end}
                          {i < item.slots.length - 1 && ", "}
                        </span>
                      ))}
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>
        </Modal>
      )}
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="account-module-view">
            <div className="account-module-heading-with-back-button">
              <div
                className="account-module-back-btn"
                onClick={() => {
                  exitPage();
                }}
              >
                <FontIcon style={{ fontSize: "36px" }}>arrow_back</FontIcon>
              </div>
              <h1>{`Customise the service provider`}</h1>
            </div>
            <div className="account-module-buttons-container">
              <div className="account-module-buttons-right-alignment">
                <Button
                  raised
                  disabled={loading}
                  className={
                    loading
                      ? "account-module-button-save-disabled"
                      : "account-module-button-save-enabled"
                  }
                  onClick={() => {
                    handleSave();
                  }}
                >
                  {"Save"}
                </Button>

                <Button
                  raised
                  disabled={loading}
                  className="account-module-button-cancel"
                  onClick={() => {
                    exitPage();
                  }}
                >
                  {"Cancel"}
                </Button>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <br />

      <br />
      {isDataFetched && (
        <div>
          <div className="mp-plan-grey-heading">Plan details</div>
          <br />

          <div className="account-module-create-service-container">
            <Row>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-plan-create-service-field-container">
                  <div className="mp-plan-label">{`Plan ID`}</div>
                  <div>
                    <TextField
                      value={fetchedPlan?.id ?? ""}
                      lineDirection="left"
                      disabled
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                <div style={{ height: "20px" }}></div>
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-plan-create-service-field-container">
                  <div className="mp-plan-label">{`Plan name`}</div>
                  <div>
                    <TextField
                      value={fetchedPlan?.basicDetails?.name ?? ""}
                      lineDirection="left"
                      disabled
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                <div style={{ height: "20px" }}></div>
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-plan-create-service-field-container">
                  <div className="mp-plan-label">{`Account name`}</div>
                  <div>
                    <TextField
                      value={fetchedAccount.accountName ?? ""}
                      lineDirection="left"
                      disabled
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <br />
          <div className="mp-plan-grey-heading">Service details</div>
          <br />

          <div className="account-module-create-service-container">
            <Row>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-plan-create-service-field-container">
                  <div className="mp-plan-label">{`Service type`}</div>
                  <div>
                    <TextField
                      value={fetchedService?.serviceTypeName ?? ""}
                      lineDirection="left"
                      disabled
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                <div style={{ height: "20px" }}></div>
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-plan-create-service-field-container">
                  <div className="mp-plan-label">{`Service ID`}</div>
                  <div>
                    <TextField
                      value={fetchedService?.id ?? ""}
                      lineDirection="left"
                      disabled
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                <div style={{ height: "20px" }}></div>
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-plan-create-service-field-container">
                  <div className="mp-plan-label">{`Service status on plan`}</div>
                  <div>
                    <TextField
                      value={
                        assignedServiceToPlan != null
                          ? assignedServiceToPlan.serviceModeDetails.find(
                              (e) => e.modeName === props?.data?.serviceMode,
                            ).isModeActive === true
                            ? "Active"
                            : "Inactive"
                          : ""
                      }
                      // value={
                      //   fetchedServiceProvider.serviceModes[0].isActive !=
                      //   undefined
                      //     ? fetchedServiceProvider.serviceModes[0].isActive ==
                      //       true
                      //       ? "Active"
                      //       : "Inactive"
                      //     : ""
                      // }
                      lineDirection="left"
                      disabled
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-plan-create-service-field-container">
                  <div className="mp-plan-label">{`Service code`}</div>
                  <div>
                    <TextField
                      value={fetchedService?.name ?? ""}
                      lineDirection="left"
                      disabled
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                <div style={{ height: "20px" }}></div>
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-plan-create-service-field-container">
                  <div className="mp-plan-label">{`Service name`}</div>
                  <div>
                    <TextField
                      value={fetchedService?.serviceName ?? ""}
                      lineDirection="left"
                      disabled
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <br />
          <div className="mp-plan-grey-heading">Service provider</div>
          <br />

          <div className="account-module-create-service-container">
            <Row>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-plan-create-service-field-container">
                  <div className="mp-plan-label">{`Service provider ID`}</div>
                  <div>
                    <TextField
                      value={fetchedServiceProvider?.serviceProviderId ?? ""}
                      lineDirection="left"
                      disabled
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                <div style={{ height: "20px" }}></div>
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-plan-create-service-field-container">
                  <div className="mp-plan-label">{`Service provider name`}</div>
                  <div>
                    <TextField
                      value={fetchedServiceProvider?.serviceProviderName ?? ""}
                      lineDirection="left"
                      disabled
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                <div style={{ height: "20px" }}></div>
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-plan-create-service-field-container">
                  <div className="mp-plan-label">{`Service provider status`}</div>
                  <div>
                    <SelectField
                      placeholder="Select"
                      className="mp-plan-select-field"
                      disabled={mode == "view" || loading}
                      menuItems={STATUS_OPTIONS}
                      value={
                        customisedSP.isActive != undefined
                          ? customisedSP.isActive
                          : ""
                      }
                      onChange={(e) => {
                        setCustomisedSP({ ...customisedSP, isActive: e });
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <br />
          <Row>
            <Col xs={12} sm={3} md={3} lg={3}>
              <div className="mp-plan-create-service-field-container">
                <div className="mp-plan-label">{`Custom discounted price`}</div>
                <div>
                  <TextField
                    value={customisedSP?.discountedPrice ?? ""}
                    lineDirection="left"
                    disabled={mode == "view" || loading}
                    onChange={(e) => {
                      if (/^\d+$/.test(e) || e === "") {
                        setCustomisedSP({
                          ...customisedSP,
                          discountedPrice: e,
                        });
                      }
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <br />
          <br />

          {fetchedService?.serviceTypeId == 4 ? (
            <>
              <div className="mp-buttons-container mp-sp-city-selection-header-container">
                <h4 className="mp-sub-heading-margin">
                  <Checkbox
                    id="mp-checkbox-3"
                    name="mp-service-provider-payment-checkbox"
                    style={{ marginLeft: -13, marginTop: 0 }}
                    disabled={mode == "view" || loading}
                    color={mode == "view" ? "default" : "secondary"}
                    checked={
                      (customisedSP?.cityMappingPlan?.cityMappingEnabled ??
                      false)
                        ? true
                        : false
                    }
                    onChange={(eve, proxy) => {
                      setCustomisedSP((prev) => ({
                        ...customisedSP,
                        cityMappingPlan: {
                          ...(prev?.cityMappingPlan ?? {}),
                          cityMappingEnabled: eve.target.checked,
                        },
                      }));
                    }}
                  />
                  {`Enable City selection`}
                </h4>
                <h4
                  ref={enablePricePerCityTextRef}
                  className="mp-sub-heading-margin"
                >
                  <Checkbox
                    id="mp-checkbox-3"
                    name="mp-service-provider-payment-checkbox"
                    style={{ marginLeft: -13, marginTop: 0 }}
                    disabled={mode == "view" || loading}
                    color={mode == "view" ? "default" : "secondary"}
                    checked={
                      (customisedSP?.cityMappingPlan?.customisedPriceEnabled ??
                      false)
                        ? true
                        : false
                    }
                    onChange={(eve, proxy) => {
                      setCustomisedSP((prev) => ({
                        ...customisedSP,
                        cityMappingPlan: {
                          ...(prev?.cityMappingPlan ?? {}),
                          customisedPriceEnabled: eve.target.checked,
                        },
                      }));
                    }}
                  />
                  {`Price as per city`}
                </h4>

                {/* showing save this SP button if initially the city selection was disabled and now we enabled it. */}
                {Boolean(
                  ((initialCityMapping?.cityMappingEnabled ?? false) !=
                    (customisedSP?.cityMappingPlan?.cityMappingEnabled ??
                      false) ||
                    (initialCityMapping?.customisedPriceEnabled ?? false) !=
                      (customisedSP?.cityMappingPlan?.customisedPriceEnabled ??
                        false)) &&
                  mode == "update",
                ) && (
                  <Button
                    raised
                    disabled={loading}
                    className={
                      loading
                        ? "mp-button-save-disabled"
                        : "mp-button-save-enabled"
                    }
                    id="save_provider"
                    onClick={() => {
                      // assignServiceProvider(
                      //   prepareBodyForAssignServiceProvider(),
                      //   undefined,
                      //   !(initialCityMapping?.cityMappingEnabled ?? false) &&
                      //     (customisedSP?.cityMapping?.cityMappingEnabled ??
                      //       false) == true
                      // );

                      handleSave();
                    }}
                  >
                    {mode == 1 ? "Save" : "Update"}
                  </Button>
                )}
                {Boolean(
                  !(
                    customisedSP?.cityMappingPlan?.customisedPriceEnabled ??
                    false
                  ) ||
                  !(initialCityMapping?.customisedPriceEnabled ?? false) ||
                  (initialCityMapping?.cityMappingEnabled ?? false) !=
                    (customisedSP?.cityMappingPlan?.cityMappingEnabled ??
                      false),
                ) ? (
                  <></>
                ) : Boolean(cityMappingOperationSelected === 2) ? (
                  <div className="mp-buttons-right-alignment">
                    <Button
                      id="save_provider"
                      raised
                      disabled={loading}
                      className={
                        loading
                          ? "mp-button-save-disabled"
                          : "mp-button-save-enabled"
                      }
                      onClick={() => {
                        if (cityMappingOperationSelected === 2) {
                          if (checkIfThereIsAnythingToUpdate()) {
                            updateCustomisedSPCityToPriceMapping();
                          } else {
                            EventService.emit("showError", {
                              message: `Nothing to update. Please update at least 1 record.`,
                            });
                          }
                        }
                      }}
                    >
                      {"Save"}
                    </Button>

                    <Button
                      id="cancel_provider"
                      raised
                      disabled={loading}
                      className="mp-button-cancel"
                      onClick={() => {
                        handleUpdateMode(originalMode);
                        setCityMappingOperationSelected(null);
                        resetAddOrUpdateCities();
                      }}
                    >
                      {"Cancel"}
                    </Button>
                  </div>
                ) : (
                  <div className="mp-buttons-right-alignment">
                    {Boolean(
                      (cityMappings?.cityEntities ?? [])?.length > 0,
                    ) && (
                      <Button
                        raised
                        disabled={loading || props?.data?.mode == "view"}
                        className={
                          loading
                            ? "mp-button-save-disabled"
                            : "mp-button-save-enabled"
                        }
                        onClick={() => {
                          handleUpdateMode("view");
                          setCityMappingOperationSelected(2);
                        }}
                      >
                        {"Update cities"}
                      </Button>
                    )}
                  </div>
                )}
              </div>

              <>
                <CityTableCustomiseSP
                  tableData={returnTableDataWithEditsApplied(
                    cityMappings ?? {},
                    tableDataEditAudits ?? {},
                  )}
                  cityMappingFilters={cityMappingFilters}
                  cityMappings={cityMappings}
                  handleUpdateTableData={handleUpdateTableCityEntity}
                  // handleUpdateNewTableData={
                  //   handleUpdateNewTableCityEntity
                  // }
                  // cityMappingOperationSelected={
                  //   cityMappingOperationSelected
                  // }
                  customisedSP={customisedSP}
                  fetchCityMappings={fetchCityMappings}
                  // serviceProviderId={props?.data?.serviceProviderId}
                  mode={cityMappingOperationSelected === 2 ? "update" : "view"}
                  cityMappingOperationSelected={cityMappingOperationSelected}
                  loading={loading}
                />
              </>
            </>
          ) : (
            <>
              {modeData?.availability && marginData && (
                <>
                  {/* ================= LEVEL 4a CARD ================= */}
                  {marginRuleDetails && ruleData && (
                    <div className="l4-container">
                      <h3 className="l4-heading">
                        Service provider calendar for this plan as defined on{" "}
                        {isLevel4B ? "Level 4b" : "Level 4a"}
                      </h3>

                      <div className="l4-card">
                        {/* Margin */}
                        {marginData && (
                          <div className="l4-margin">
                            <div className="margin-label">Margin</div>
                            <span
                              className="margin-pill"
                              style={{ background: marginData.colour }}
                            >
                              {marginData.name}
                            </span>
                          </div>
                        )}

                        {/* Available Days */}
                        <div className="l4-days-section">
                          <div className="section-label">
                            Available days per week
                          </div>

                          <div className="days-row">
                            {ruleData?.calendarConfig?.weekDays &&
                              Object.entries(
                                ruleData.calendarConfig.weekDays,
                              ).map(([day, enabled]) => (
                                <div
                                  key={day}
                                  className={`day-pill ${
                                    enabled === true || enabled === "true"
                                      ? "active-day"
                                      : "inactive-day"
                                  }`}
                                >
                                  {day.slice(0, 3).charAt(0).toUpperCase() +
                                    day.slice(1, 3)}
                                </div>
                              ))}
                          </div>
                        </div>

                        {/* Config Row */}
                        <div className="l4-config-row">
                          <div className="config-box">
                            <div className="config-label">Days per week</div>
                            <div className="config-value">
                              {ruleData.calendarConfig.weekEnabledDaysCount}{" "}
                              Days
                            </div>
                          </div>

                          <div className="config-box">
                            <div className="config-label">Booking per slot</div>
                            <div className="config-value">
                              {ruleData.calendarConfig.bookingsPerSlot}
                            </div>
                          </div>

                          <div
                            className="view-calendar-btn clickable"
                            onClick={() => {
                              const currentMonth = moment();
                              setCalendarMonth(currentMonth);
                              setShowCalendarModal(true);
                              fetchCalendar(currentMonth);
                            }}
                          >
                            <span> View calendar</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="master-weekly-container">
                    <h3 className="master-heading">
                      Service provider “master weekly schedule” for this service
                      as defined on level 2
                    </h3>

                    <div className="master-card">
                      {Object.entries(
                        marginRuleDetails?.l2Availability?.schedule ?? {},
                      ).map(([day, slots]) => {
                        const isDisabled = !slots || slots.length === 0;

                        return (
                          <div key={day} className="master-row">
                            <div
                              className={`master-day ${
                                isDisabled ? "disabled-day" : ""
                              }`}
                            >
                              {day.charAt(0).toUpperCase() + day.slice(1)}
                            </div>

                            <div className="master-slots">
                              {!isDisabled &&
                                slots.map((slot, index) => (
                                  <span key={index} className="slot-pill">
                                    {slot.start} - {slot.end}
                                  </span>
                                ))}
                            </div>
                          </div>
                        );
                      })}

                      <div className="master-config-row">
                        <div>
                          <div className="config-label">Duration (mins)</div>
                          <div className="config-value">
                            {
                              modeData.masterAvailability.config
                                .slotDurationInMinutes
                            }
                          </div>
                        </div>

                        <div>
                          <div className="config-label">Booking per slot</div>
                          <div className="config-value">
                            {modeData.masterAvailability.config.bookingPerSlot}
                          </div>
                        </div>

                        <div>
                          <div className="config-label">
                            Min booking notice (days)
                          </div>
                          <div className="config-value">
                            {modeData.masterAvailability.config.minBookingDays}
                          </div>
                        </div>

                        <div>
                          <div className="config-label">
                            Max advance booking (days)
                          </div>
                          <div className="config-value">
                            {
                              modeData.masterAvailability.config
                                .maxAdvBookingDays
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="master-buttons">
                      <div
                        className="purple-btn clickable"
                        onClick={() => setShowAvailabilityModal(true)}
                      >
                        Availability beyond master weekly schedule
                      </div>

                      <div
                        className="purple-btn clickable"
                        onClick={() => setShowUnavailabilityModal(true)}
                      >
                        Unavailability beyond master weekly schedule
                      </div>
                    </div>
                  </div>
                </>
              )}

              {!marginRuleDetails && (
                <>
                  {" "}
                  <AvailabilityCalendar
                    availability={customisedSP.providerAvailability}
                    setAvailability={setAvailability}
                    mode={1}
                    headings={[
                      "Customised weekly schedule of the provider for this service on this plan",
                    ]}
                    showOnlySchedule={true}
                    slotsValidationSchedule={
                      fetchedServiceProvider.serviceModes[0].masterAvailability
                        .schedule
                    }
                  />
                  <br />
                  <div className="account-module-create-service-container">
                    <Row>
                      <Col xs={12} sm={3} md={3} lg={3}>
                        <div className="mp-plan-create-service-field-container">
                          <div className="mp-plan-label">
                            {`Duration (mins)`}
                            <label className="mp-label-red"> *</label>
                          </div>
                          <div>
                            <TextField
                              value={
                                customisedSP.providerAvailability.config
                                  .slotDurationInMinutes ?? ""
                              }
                              lineDirection="left"
                              helpOnFocus
                              helpText={
                                fetchedServiceProvider.serviceModes[0]
                                  .masterAvailability.config
                                  .slotDurationInMinutes != undefined
                                  ? `Value can't exceed ${fetchedServiceProvider.serviceModes[0].masterAvailability.config.slotDurationInMinutes}`
                                  : false
                              }
                              onChange={(e) => {
                                if (
                                  (/^\d+$/.test(e) || e === "") &&
                                  Number(e) <=
                                    fetchedServiceProvider.serviceModes[0]
                                      .masterAvailability.config
                                      .slotDurationInMinutes
                                ) {
                                  setCustomisedSP({
                                    ...customisedSP,
                                    providerAvailability: {
                                      ...customisedSP.providerAvailability,
                                      config: {
                                        ...customisedSP.providerAvailability
                                          .config,
                                        slotDurationInMinutes: Number(e),
                                      },
                                    },
                                  });
                                }
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={1} md={1} lg={1}>
                        <div style={{ height: "20px" }}></div>
                      </Col>
                      <Col xs={12} sm={3} md={3} lg={3}>
                        <div className="mp-plan-create-service-field-container">
                          <div className="mp-plan-label">
                            {`Booking per slot`}
                            <label className="mp-label-red"> *</label>
                          </div>
                          <div>
                            <TextField
                              value={
                                customisedSP.providerAvailability.config
                                  .bookingPerSlot ?? ""
                              }
                              lineDirection="left"
                              helpOnFocus
                              helpText={
                                fetchedServiceProvider.serviceModes[0]
                                  .masterAvailability.config.bookingPerSlot !=
                                undefined
                                  ? `Value can't exceed ${fetchedServiceProvider.serviceModes[0].masterAvailability.config.bookingPerSlot}`
                                  : false
                              }
                              onChange={(e) => {
                                if (
                                  (/^\d+$/.test(e) || e === "") &&
                                  Number(e) <=
                                    fetchedServiceProvider.serviceModes[0]
                                      .masterAvailability.config.bookingPerSlot
                                ) {
                                  setCustomisedSP({
                                    ...customisedSP,
                                    providerAvailability: {
                                      ...customisedSP.providerAvailability,
                                      config: {
                                        ...customisedSP.providerAvailability
                                          .config,
                                        bookingPerSlot: Number(e),
                                      },
                                    },
                                  });
                                }
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={3} md={3} lg={3}>
                        <div className="mp-plan-create-service-field-container">
                          <div className="mp-plan-label">
                            {`Min booking notice (days)`}
                            <label className="mp-label-red"> *</label>
                          </div>
                          <div>
                            <TextField
                              value={
                                customisedSP.providerAvailability.config
                                  .minBookingDays ?? ""
                              }
                              lineDirection="left"
                              helpOnFocus
                              helpText={
                                fetchedServiceProvider.serviceModes[0]
                                  .masterAvailability.config.minBookingDays !=
                                undefined
                                  ? `Value can be minimum ${fetchedServiceProvider.serviceModes[0].masterAvailability.config.minBookingDays}`
                                  : false
                              }
                              onChange={(e) => {
                                if (/^\d+$/.test(e) || e === "") {
                                  setCustomisedSP({
                                    ...customisedSP,
                                    providerAvailability: {
                                      ...customisedSP.providerAvailability,
                                      config: {
                                        ...customisedSP.providerAvailability
                                          .config,
                                        minBookingDays: Number(e),
                                      },
                                    },
                                  });
                                }
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={1} md={1} lg={1}>
                        <div style={{ height: "20px" }}></div>
                      </Col>
                      <Col xs={12} sm={3} md={3} lg={3}>
                        <div className="mp-plan-create-service-field-container">
                          <div className="mp-plan-label">
                            {`Max advance booking (days)`}
                            <label className="mp-label-red"> *</label>
                          </div>
                          <div>
                            <TextField
                              value={
                                customisedSP.providerAvailability.config
                                  .maxAdvBookingDays ?? ""
                              }
                              lineDirection="left"
                              helpOnFocus
                              helpText={
                                fetchedServiceProvider.serviceModes[0]
                                  .masterAvailability.config
                                  .maxAdvBookingDays != undefined
                                  ? `Value can't exceed ${fetchedServiceProvider.serviceModes[0].masterAvailability.config.maxAdvBookingDays}`
                                  : false
                              }
                              onChange={(e) => {
                                if (
                                  (/^\d+$/.test(e) || e === "") &&
                                  Number(e) <=
                                    fetchedServiceProvider.serviceModes[0]
                                      .masterAvailability.config
                                      .maxAdvBookingDays
                                ) {
                                  setCustomisedSP({
                                    ...customisedSP,
                                    providerAvailability: {
                                      ...customisedSP.providerAvailability,
                                      config: {
                                        ...customisedSP.providerAvailability
                                          .config,
                                        maxAdvBookingDays: Number(e),
                                      },
                                    },
                                  });
                                }
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      )}

      {/* Error Dialog */}
      {Boolean(
        Boolean(errorObject) &&
        Boolean(errorObject?.operation === 1 || errorObject?.operation === 2),
      ) && (
        <div className="modal-overlay">
          <div className="modal error-modal">
            <h3>
              Error{" "}
              {errorObject?.operation === 1
                ? "Adding"
                : errorObject?.operation === 2
                  ? "Updating"
                  : ""}{" "}
              City/Cities
            </h3>
            <div className="error-modal-content" style={{ textAlign: "left" }}>
              <p>
                {(errorObject?.totalRequested ?? 0) -
                  (errorObject?.totalErrors ?? 0)}{" "}
                out of {errorObject?.totalRequested ?? 0} city/cities have been{" "}
                {errorObject?.operation === 1
                  ? "added"
                  : errorObject?.operation === 2
                    ? "updated"
                    : ""}{" "}
                successfully but there are some errors in{" "}
                {errorObject?.totalErrors ?? 0} city/cities, please rectify and
                try again
              </p>

              <div
                style={{
                  maxHeight: "200px",
                  overflowY: "auto",
                  textAlign: "left",
                  paddingRight: "10px",
                }}
              >
                {errorObject?.operation === 1
                  ? Object.entries(errorObject?.errorResponse ?? {}).map(
                      ([city, errMsg], index) => (
                        <div key={index} style={{ marginBottom: "10px" }}>
                          <strong>City:</strong> {city} <br />
                          <strong>Error:</strong> {errMsg}
                        </div>
                      ),
                    )
                  : errorObject?.operation === 2
                    ? Object.entries(errorObject?.errorResponse ?? {}).map(
                        ([key, value], index) => (
                          <div key={index} style={{ marginBottom: "10px" }}>
                            <strong>City:</strong> {value?.city} <br />
                            <strong>Error:</strong> {value?.errorMessage}
                          </div>
                        ),
                      )
                    : ""}
              </div>
            </div>

            <div style={{ height: "32px" }}></div>
            <Button
              raised
              className={"mp-button-save-enabled"}
              onClick={() => setErrorObject(null)}
            >
              {"Okay"}
            </Button>
            <div style={{ height: "32px" }}></div>
          </div>
        </div>
      )}

      {showUpdateCityMappingNowDialog && (
        <DialogContainer
          id="mp-calendar-changes-prop-confirm-dialog"
          visible={showUpdateCityMappingNowDialog}
          focusOnMount={false}
          onHide={() => {
            // setOpenPropCalendarChangesDialog(false);
            // setSPbodyToUpdate(null);
            // setLoading(false);
          }}
          width="600px"
          autosizeContent
          height="auto"
          style={{ textAlign: "left", zIndex: 200 }}
          dialogStyle={{ borderRadius: "10px", position: "relative" }}
        >
          <div className="mp-confirm-diaglog-1">
            <h3>{`Service provider customised ${
              mode == 1 ? `created` : mode == 3 ? `updated` : ``
            } successfully!`}</h3>
            <br />
            <div>{`Do you want to add/update cities now or later?`}</div>
            <br />
            {/* <div>{`in the default calendar and customised calendar?`}</div> */}
            <br />
            <div className="mp-confirm-diaglog-btn">
              <div className="mp-buttons-right-alignment">
                <Button
                  raised
                  disabled={loading}
                  className={"mp-button-save-enabled"}
                  onClick={() => {
                    setLoading(false);
                    setShowUpdateCityMappingNowDialog(false);
                    reFetchPageData();

                    handleUpdateMode("update");
                    scrollToPricePerCityHeading();
                  }}
                >
                  {"Now"}
                </Button>

                <Button
                  raised
                  disabled={loading}
                  className="mp-button-cancel"
                  onClick={() => {
                    setLoading(false);
                    setShowUpdateCityMappingNowDialog(false);
                    exitPage();
                  }}
                >
                  {"Later"}
                </Button>
              </div>
            </div>
          </div>
        </DialogContainer>
      )}
    </div>
  );
};

export default CustomiseServiceProvider;
